// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardSelectorStageMobile__container--rXGwW {
    display: flex;
    justify-content: center;
    width: 100%;
}

    @media screen and (min-width: 1024px) {.CardSelectorStageMobile__container--rXGwW {
        display: none
}
    }

.CardSelectorStageMobile__cardImage--ErTW3 {
    width: 100%;
    height: auto;
    max-width: 200px;
    margin: 0 auto;
    aspect-ratio: 0.64;
    border-radius: 6px;
}

.CardSelectorStageMobile__buttons--FbYwa {
    padding: 0 24px;
    width: 100%;
    display: grid;
    grid-template-columns: 0.6fr 0.4fr;
    grid-gap: 16px;
}

.CardSelectorStageMobile__cardsLeftText--EuYNj {
    color: var(--premium-solid-color);
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.16px;
    text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/components/CardSelectorStageMobile/CardSelectorStageMobile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AAKf;;IAHI,uCALJ;QAMQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    @media (--large) {\n        display: none;\n    }\n}\n\n.cardImage {\n    width: 100%;\n    height: auto;\n    max-width: 200px;\n    margin: 0 auto;\n    aspect-ratio: 0.64;\n    border-radius: 6px;\n}\n\n.buttons {\n    padding: 0 24px;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 0.6fr 0.4fr;\n    grid-gap: 16px;\n}\n\n.cardsLeftText {\n    color: var(--premium-solid-color);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.16px;\n    text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CardSelectorStageMobile__container--rXGwW`,
	"cardImage": `CardSelectorStageMobile__cardImage--ErTW3`,
	"buttons": `CardSelectorStageMobile__buttons--FbYwa`,
	"cardsLeftText": `CardSelectorStageMobile__cardsLeftText--EuYNj`
};
export default ___CSS_LOADER_EXPORT___;
